import { Asha } from "@microsoft/oteljs";
import { EventType } from "@ms/uno-telemetry/lib/local/UTelLogHandler";
import { logEvent } from "@ms/uno-telemetry/lib/local/LoggingHelper";
/**
 * Logs the event using UTelJs
 * @param event Event to be logged
 * @param logHandler Log handler to log event
 */ function LogUTel(event, logHandler) {
    // Get the data field
    const dataField = Asha.getFields(event);
    // Log the event
    logHandler.log({
        type: EventType.Asha,
        payload: dataField
    });
}
/**
 * Logs the event with all available loggers
 * @param event Event to be logged
 * @param logHandler Log handler to log event
 */ export function Log(event, logHandler) {
    // Log the event
    logEvent(event, LogUTel, logHandler);
}
